import { ColScaffold } from "../../interface";

/**
 * Builds a list of column entries for a range between two columns.
 * Includes all columns whose colNumber falls between the anchor and target (inclusive).
 *
 * @param cols - All available scaffold columns.
 * @param anchorColId - The column ID of the selection anchor.
 * @param targetColId - The column ID of the target column.
 * @returns An array of column selection entries covering the range.
 */
export const buildColRange = <T>(
  cols: ColScaffold<T>[],
  anchorColId: string,
  targetColId: string,
): { firstCellId: string }[] => {
  const anchorCol = cols.find((c) => c.id === anchorColId);
  const targetCol = cols.find((c) => c.id === targetColId);

  if (!anchorCol || !targetCol) {
    return [];
  }

  const minColNum = Math.min(anchorCol.colNumber, targetCol.colNumber);
  const maxColNum = Math.max(anchorCol.colNumber, targetCol.colNumber);

  return cols
    .filter((c) => c.colNumber >= minColNum && c.colNumber <= maxColNum)
    .map((c) => ({ firstCellId: c.id }));
};
